import { CssBaseline } from "@mui/material";
import ContactManagementApp from "./components/ContactManagementApp/ContactManagementApp";

function App() {
  return (
    <div className="App">
      <CssBaseline />
      <ContactManagementApp />
    </div>
  );
}

export default App;